// @flow

import * as R from "ramda";
import type { HomescreenSection } from "src/types";

/**
 * Formats sections into center and right sections based on their settings
 * @param {Array<Object>} sections - list of all the homescreen sections
 * @return an object containing a list of center and right sections
 **/
export const formatSections = (
  sections: Array<HomescreenSection>,
): {
  centerSections: Array<HomescreenSection>;
  rightSections: Array<HomescreenSection>;
} => {
  let centerSections: Array<HomescreenSection> = [];
  let rightSections: Array<HomescreenSection> = [];

  sections.forEach((section) => {
    if (section?.settings?.position === "right") {
      rightSections.push(section);
    } else {
      centerSections.push(section);
    }
  });

  centerSections = R.sortBy(R.prop("seqNo"), centerSections);
  rightSections = R.sortBy(R.prop("seqNo"), rightSections);

  return { centerSections, rightSections };
};
